import ApiBase from './ApiBase';
import axios from 'axios';
import { saveAs } from 'file-saver';

/**
 * Document API (related to report table)
 */
class DocumentApi extends ApiBase {
  /**
   * Soft delete documents
   * @param {*} documents List of documents
   */
  async deleteDocuments(documents) {
    const request = {
      url: `${this.API_URL}/document/setstatuses`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(documents)
    };

    const response = await axios.request(request);

    if (response.status === 404) {
      return;
    }

    return response.data;
  }

  /**
   * Assign split document data
   * @param {*} resourceUploadId
   * @param {*} documents
   */
  async assignDocuments(resourceUploadId, documents) {
    const request = {
      url: `${this.API_URL}/documents?resourceUploadId=${resourceUploadId}`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(documents),
      validateStatus: function(status) {
        return (status >= 200 && status < 300) || status === 400;
      }
    };

    const response = await axios.request(request);

    if (response.status === 400) {
      throw new Error(response.data.errorMessage);
    }
    return response.data;
  }

  /**
   * Set single document status
   * @param {*} documentId
   * @param {*} data
   */
  async setSingleStatus(documentId, data) {
    const headers = this.getHeaders();
    const request = {
      url: `${this.API_URL}/document/setstatus?documentId=${documentId}`,
      headers: headers,
      method: 'POST',
      data: data
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Set mulitple documents status
   * @param orignalDocumentId
   * @param {*} data
   */
  async copyToAnotherInvestors(orignalDocumentId, data) {
    const headers = this.getHeaders();
    const request = {
      url: `${this.API_URL}/document/copytoanotherinvestors?id=${orignalDocumentId}`,
      headers: headers,
      method: 'POST',
      data: JSON.stringify(data)
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Set mulitple documents status
   * @param {*} data
   */
  async setMultipleStatus(data) {
    const headers = this.getHeaders();
    const request = {
      url: `${this.API_URL}/document/setstatuses`,
      headers: headers,
      method: 'POST',
      data: data
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Download uploaded file
   * @param {*} documentId
   * @param progress
   */
  async download(documentId, progress) {
    const request = {
      url: `${this.API_URL}/document/download?documentId=${documentId}&accessType=DOWNLOAD`,
      headers: this.getHeaders(),
      method: 'GET',
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        if (progressEvent.lengthComputable) {
          if (typeof progress === 'function') {
            progress(progressEvent.loaded, progressEvent.total);
          }
        }
      }
    };

    const response = await axios.request(request);

    return response;
  }

  async downloadDocumentAsFile(documentId, fileName) {
    const response = await this.download(documentId);
    saveAs(response.data, fileName);
  }
}

export default new DocumentApi();
